import { PageDetailCardSkeleton } from '@/shared/ui/Skeleton'
import { Skeleton } from '@/shared/ui/Skeleton'

export const MissionShowSkeleton = () => (
  <div className="flex flex-col gap-0" aria-busy aria-label="Carregando missão">
    <Skeleton className="mb-4 h-[5.5rem] w-full rounded-xl" />
    <PageDetailCardSkeleton lines={4} />
    <PageDetailCardSkeleton lines={2} withIconTitle={false} />
  </div>
)
